import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createStaffMember } from '@services/registry';

export function useCreateStaffMember({ tenantId }) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: async ({ email, password, profile }) => {
            return await createStaffMember({ tenantId, email, password, profile });
        },
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: ['staff', tenantId] });
        },
    });
}

